(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-night-view-feature"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.ai-night-view-section');
    if (!section) return;
    window.initAnimatedText('.ai-night-view-title');
  });

  } catch(e) { console.error(e); }
})();
})();
